import { Outlet } from "react-router-dom";

const LenderApplicationLayout = () => {
  return <Outlet />;
};

export default LenderApplicationLayout;
